<div class="spinner-wrapper" style="border-color:white !important ;">
  <div class="donut"></div>
</div>